export interface AuthSession {
  sub: string
  email: string
  name?: string
  picture?: string
}

export async function fetchSession(): Promise<AuthSession | null> {
  const res = await fetch('/auth/me', { credentials: 'same-origin' })
  if (res.status === 401) return null
  if (!res.ok) throw new Error(`/auth/me failed: ${res.status}`)
  return (await res.json()) as AuthSession
}

export async function logout(): Promise<void> {
  await fetch('/auth/logout', { method: 'POST', credentials: 'same-origin' })
}

export function loginWithGoogle(): void {
  window.location.href = '/auth/google'
}
